import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const useAuth = (redirectTo = '/') => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const checkAuth = async () => {
            // Simulate wait time for auth token to be set after MSAL redirect
            await new Promise(resolve => setTimeout(resolve, 100)); // small delay

            const token = localStorage.getItem('authToken');
            if (!token) {
                navigate(redirectTo);
            }

            setLoading(false);
        };

        checkAuth();
    }, [navigate, redirectTo]);

    return loading; // ⬅️ return loading status
};

export default useAuth;
